import { UserId } from 'features/users/types';

export enum PermissionTypes {
  broadcastVideo = 'broadcast_video',
  broadcastAudio = 'broadcast_audio',
  manageBroadcast = 'manage_broadcast',
  endSession = 'end_session',
  startSession = 'start_session',
  removeParticipant = 'remove_participant',
  screenshare = 'screenshare',
  manageScreenshare = 'manage_screenshare',
  recording = 'recording',
  restreaming = 'restreaming',
  generalChat = 'general_chat',
  privateChat = 'private_chat',
  deleteOthersChatMessages = 'delete_others_chat_messages',
  exportChat = 'export_chat',
  clearChat = 'clear_chat',
  remoteMuting = 'remote_muting',
  askRemoteUnmute = 'ask_remote_unmute',
  raiseHand = 'raise_hand',
  manageRoles = 'manage_roles',
  managePrivateWhiteboards = 'manage_private_whiteboard',
  manageEditWhiteboard = 'manage_edit_whiteboard',
  managePresentContent = 'manage_present_content',
  inviteParticipant = 'invite_participant',
  seeParticipantsPanel = 'see_participants_panel',
  controlRoomEntry = 'control_room_entry',
  editWhiteboard = 'edit_whiteboard',
  manageBreakout = 'manage_breakout',
  moderateQA = 'moderate_qa',
  answerQA = 'answer_qa',
  downloadQa = 'download_qa',
  askQuestionQa = 'ask_question_qa',
  askQuestionAnonymously = 'ask_question_anonymously_qa',
  accessQa = 'access_qa',
  seeAllQuestions = 'see_all_questions',
  seeContentBadges = 'see_content_badges',
  controlRoomComponents = 'control_room_components',
  presentFiles = 'present_files',
  managePolls = 'manage_polls',
  managePollTemplates = 'manage_poll_templates',
  takePolls = 'take_polls',
  upvoteQA = 'upvote_qa',
  transcribeSession = 'transcribe_session',
  manageContentLibrary = 'manage_content_library',
  presentContentLibrary = 'present_content_library',
  managePersonalContentLibrary = 'manage_personal_content_library',
  pushContent = 'push_content',
  lockContent = 'lock_content',
  seeNotes = 'see_notes',
  collaborateInNotes = 'collaborate_in_notes',
  managePhoneUsers = 'manage_phone_users',
  banParticipants = 'ban_participants',
  clearContent = 'clear_content',
  seeQuestionsAuthor = 'see_questions_author',
  seeRolesInParticipantsPanel = 'see_roles_in_participants_panel',
  answerQuestionPrivately = 'answer_privately_qa',
  renameParticipants = 'rename_participants',
  selfRename = 'self_rename',
  roomReactions = 'room_reactions',
  chatReactions = 'chat_reactions',
  avatarUpload = 'avatar_upload',
  pinPanels = 'pin_panels',
}

export type RoleEntries = Record<string, Role>;

export interface Role {
  name: string;
  displayNameKey?: string;
  displayName: string;
  permissions: Permission[];
}

export interface Permission {
  name: PermissionTypes;
  targetRoles?: string[];
}

export type RolePermissions = Record<string, Record<string, boolean>>;
export type TargetRolesMap = Record<string, Partial<Record<string, string[]>>>;
export type CoverageAcrossRoles = Record<string, boolean>;

export interface PermissionsState {
  defaultRole: string;
  byRole: RoleEntries;
  allRoles: string[];
  rolePermissions: RolePermissions;
  targetRolesMap: TargetRolesMap;
  coverageAcrossRoles: CoverageAcrossRoles;
}

export interface ManageBroadcastPayload {
  id: UserId;
  audio: boolean;
  video: boolean;
}

export interface BulkAllowBroadcastPayload {
  roles: string[];
  audio: boolean;
  video: boolean;
}

export interface BulkDisallowBroadcastPayload {
  roles: string[];
}

export interface BulkScreensharePayload {
  roles: string[];
  skipUsers?: UserId[];
}

export interface BulkEditWhiteboardPayload {
  roles: string[];
}

export interface BulkPresentContentPayload {
  roles: string[];
}
